import React, { useEffect } from 'react';

import {
  Button,
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@ais-ui/ui-core';
import { useOnMapPanelExit } from '../Map/MapPanel/useOnMapPanelExit';
import { AtonList } from './AtonList';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { CreatePhysicalAton } from './Mutations/CreatePhysicalAton';
import { CreateVirtualAton } from './Mutations/CreateVirtualAton';
import { useAtonContext } from './AtonContext';
import { EditPhysicalAton } from './Mutations/EditPhysicalAton';
import { EditVirtualAton } from './Mutations/EditVirtualAton';

interface AtonsProps {
  onExit: () => void;
  requiresMap: boolean;
  className: string;
}

const AtonMutationDialogs = () => {
  const {
    showCreatePhysicalAton,
    showCreateVirtualAton,
    showEditPhysicalAton,
    showEditVirtualAton,
  } = useAtonContext();

  return (
    <>
      {showCreatePhysicalAton && <CreatePhysicalAton />}
      {showCreateVirtualAton && <CreateVirtualAton />}
      {showEditPhysicalAton && <EditPhysicalAton />}
      {showEditVirtualAton && <EditVirtualAton />}
    </>
  );
};

export const Atons = React.memo(
  ({ onExit, requiresMap, className }: AtonsProps) => {
    const { messages } = useLocalization();

    return (
      <Card className={cn('flex flex-col', className)}>
        <CardHeader>
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <CardTitle className="text-lg font-medium text-muted-foreground">
                {messages.atonListTitle}
              </CardTitle>
              <Button
                variant="ghost"
                size="icon"
                className="-mt-8 -mr-4"
                onClick={onExit}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                  className="h-4 w-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </Button>
            </div>
          </div>
          <CardDescription>{messages.atonListSubtitle}</CardDescription>
        </CardHeader>
        <AtonList requiresMap={requiresMap} />
        {requiresMap && <AtonMutationDialogs></AtonMutationDialogs>}
      </Card>
    );
  }
);

Atons.displayName = 'Atons';
